import styled from 'styled-components'
import { Row, Col } from 'antd';

const EnergyPerformance = ({ data }: any) => {
  return (
    <>
      <Row>
        <Col>
        </Col>
      </Row>
    </>
  )
}

export default EnergyPerformance